module.exports = __webpack_public_path__ + "img/Numerai-Sigil-White-Glitch8.a2fcd49c.gif";